import { render, staticRenderFns } from "./MyCourseList.vue?vue&type=template&id=8ecd38ae&scoped=true&"
import script from "./MyCourseList.vue?vue&type=script&lang=js&"
export * from "./MyCourseList.vue?vue&type=script&lang=js&"
import style0 from "./MyCourseList.vue?vue&type=style&index=0&id=8ecd38ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecd38ae",
  null
  
)

component.options.__file = "MyCourseList.vue"
export default component.exports